import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Accuware20"
});
const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.28619 3.8366L6.71497 17.4549L19.3655 10.1511L7.28619 3.8366Z"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.55",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.91635 8.44715L2.20073 9.69085L6.71221 17.5051L14.5931 16.5236L9.91635 8.44715Z"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.7",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.92871 8.44603L14.8636 2.38587L19.3641 10.15L14.5917 16.5227L9.92871 8.44603Z"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.346587",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.94732 8.43347L14.8877 2.38282L7.31975 3.88233L2.23719 9.68668L9.94732 8.43347Z"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
var Accuware20 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { Accuware20 as default };
